@use 'ui/styles/core-tokens' as core;

.domain {
  padding-top: 16px;
}
